<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getBranchSummary)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="医馆名称">
            <el-select v-model="searchForm.deptIds" multiple placeholder="请选择医馆名称">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="月份">
            <el-date-picker v-model="searchForm.date" value-format="yyyy-MM" type="monthrange" align="right"
            unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
            :picker-options="pickerOptions" @change="val => $setDates(val, getBranchSummary)"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getBranchSummary, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getBranchSummary, { deptIds: [], dates: [], date: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button @click="$exportSummary(searchForm, '/report/export/dept', '分馆总表统计')"
        icon="el-icon-download" type="primary">导出报表</el-button>
      </div>
      <!-- 分馆总表统计列表 -->
      <el-table v-loading="loading" :data="branchSummaryList" :max-height="tableHeight" border>
        <el-table-column label="分馆名称" prop="deptName" fixed min-width="80"/>
        <el-table-column label="总销售(元)" prop="totalPrice" min-width="90"/>
        <el-table-column label="毛利(元)" prop="maoriForehead" min-width="80"> </el-table-column>
        <el-table-column label="毛利率" prop="grossProfitMargin" min-width="80"> </el-table-column>
        <el-table-column label="门诊量(个)" prop="registerNumber" min-width="90"/>
        <el-table-column label="新增门诊(个)" prop="addRegister" min-width="110"/>
        <el-table-column label="处方数(张)" prop="recipeNumber" min-width="90"/>
        <el-table-column label="跑单数(个)" prop="runSingleNumber" min-width="90"/>
        <el-table-column label="现场销售(个)" prop="liveTotalPrice" min-width="110"/>
        <el-table-column label="现场客单(个)" prop="liveNumber" min-width="110"/>
        <!-- <el-table-column label="网诊销售(个)" prop="" min-width="110"/>
        <el-table-column label="网诊客单(个)" prop="" min-width="110"/> -->
        <el-table-column label="复购客单(个)" prop="repetitionNumber" min-width="110"/>
        <el-table-column label="零售销售(元)" prop="retailTotalPrice" min-width="110"/>
        <el-table-column label="零售毛利(元)" prop="retailMaoriForehead" min-width="110"/>
        <el-table-column label="零售客单(个)" prop="retailNumber" min-width="110"/>
        <el-table-column label="外来销售(元)" prop="outTotalPrice" min-width="110"/>
        <el-table-column label="外来客单(个)" prop="outNumber" min-width="110"/>
      </el-table>
      <!-- 分页 -->
      <!-- <el-pagination @current-change="page => $handleCurrentChange(page, getBranchSummary)" :current-page="currentPage" :page-size="pageSize" 
        layout="total, prev, pager, next, jumper" :total="total"/> -->
    </div>
  </div>
</template>

<script lang="js">
import { branchSummaryStatistics } from "@/api/statement"; // 报表统计请求
export default {
  name: 'DeptSummary',
  data() {
    return {
      loading: false, // 加载中
      searchForm: { deptIds: [], dates: [], date: null }, // 查询表单
      branchSummaryList: [], // 分馆总表统计列表
      // currentPage: 1, // 当前页
      // pageSize: 10, // 显示条数
      // total: 0, // 总条数
      deptOptions: this.$session.get('options'), // 医馆列表
      pickerOptions:{ // 排班日期可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: this.$shortcuts
      },
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.$forceUpdate();
    this.$setCurMonth(this.getBranchSummary);
  },
  methods: {
    // 请求所有分馆总表统计列表
    async getBranchSummary() {
      let { rows, code, total } = await branchSummaryStatistics(/* this.currentPage, this.pageSize, */ this.searchForm);
      if (code == 200) {
        this.branchSummaryList = rows;
        this.total = total;
      }
      this.loading = false;
    }
  },
};
</script>